import { Link } from '@synapex/shared2/gateway-rest-api';
import { SnakeIdObj } from '@synapex/tools/typescript';

export const siteLinksByGroup = (
  p: SnakeIdObj<'site_links_group'>,
  siteLinks: Link.Site.ManyReply,
) =>
  siteLinks.filter(
    (link) => link.site_links_group_id === p.site_links_group_id,
  );

export const channelLinksByGroup = (
  p: SnakeIdObj<'channel_links_group'>,
  channelLinks: Link.Channel.ManyReply,
) =>
  channelLinks.filter(
    (link) => link.invite_links_group_id === p.channel_links_group_id,
  );
